if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initContactForm)
} else {
    setTimeout(() => {
        initContactForm()
    }, 300)
}

function initContactForm() {
    let submit = document.getElementById("contact-submit")

    if(!submit) return

    let math = document.getElementById("math")
    let message = document.getElementById("message")
    let number_1 = parseInt(document.getElementById("number_1").value)
    let number_2 = parseInt(document.getElementById("number_2").value)

    window.onload = function () {
        submit.setAttribute("disabled", "")
    }

    function checkDisabled() {
        const message = document.getElementById("message").value
        const messageError = document.getElementById("messageError")
        const wordsToCheck = ["ich", "und", "ist", "mit", "hallo"]
        let foundWords = []
        const cleanText = message.toLowerCase().replace(/[^\w\s]/g, "")
        const tokenizedText = cleanText.split(/\s+/)

        wordsToCheck.forEach(word => {
            if (tokenizedText.includes(word.toLowerCase())) {
                foundWords.push(word)
            }
        })

        if (foundWords.length > 0) {
            messageError.style.display = "none"
        } else {
            if (message.length > 10) {
                messageError.style.display = "block"
            }
        }


        if (math.value !== undefined && math.value.toString().length > 3) {
            math.value = math.value.substring(0, math.value.length - 1)
        }
        if (parseInt(math.value) === (number_1 + number_2) && foundWords.length > 0) {
            submit.removeAttribute("disabled")
        } else {
            submit.setAttribute("disabled", "")
        }
    }

    math.addEventListener("input", () => {
        checkDisabled()
    })

    message.addEventListener("input", () => {
        checkDisabled()
    })
}